import React from 'react'
import type { ReactNode } from 'react';

import type { DialogProps as MuiDialogProps} from '@mui/material';
import { Dialog as MuiDialog, LinearProgress } from '@mui/material'

import type { DialogTitleProps } from '../DialogTitle/DialogTitle';
import DialogTitle from '../DialogTitle/DialogTitle'

export interface DialogProps extends Omit<MuiDialogProps, 'title'> {
  title?: ReactNode
  DialogTitleProps?: Omit<DialogTitleProps, 'children'>
  loading?: boolean
}

const Dialog = ({ children, loading, title, DialogTitleProps, ...props }: DialogProps) => (
  <MuiDialog {...props}>
    {title && (
      <DialogTitle {...DialogTitleProps} onClose={props.onClose}>
        {title}
      </DialogTitle>
    )}
    {loading && <LinearProgress variant="query" />}
    {children}
  </MuiDialog>
)

export default Dialog
